var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_2072_13253)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint1_linear_2072_13253)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9335 43.6945C43.7757 43.6945 46.0797 41.3904 46.0797 38.5481C46.0797 35.706 43.7757 33.4019 40.9335 33.4019C38.0912 33.4019 35.7871 35.706 35.7871 38.5481C35.7871 41.3904 38.0912 43.6945 40.9335 43.6945ZM47.7887 38.5481C47.7887 42.3343 44.7195 45.4035 40.9335 45.4035C37.1473 45.4035 34.0781 42.3343 34.0781 38.5481C34.0781 34.7621 37.1473 31.6929 40.9335 31.6929C44.7195 31.6929 47.7887 34.7621 47.7887 38.5481Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7133 42.0929C37.0549 42.5123 36.9919 43.1291 36.5725 43.4707C33.0127 46.3703 29.3055 48.3938 26.0282 49.2778C22.7972 50.1494 19.7115 49.9717 17.7588 48.019C15.5908 45.8511 15.6044 42.2943 16.8389 38.6348C17.0118 38.1223 17.5674 37.847 18.0799 38.0199C18.5924 38.1928 18.8677 38.7484 18.6948 39.2609C17.5231 42.7342 17.8017 45.292 19.1437 46.634C20.349 47.8393 22.5297 48.1929 25.5181 47.3868C28.4602 46.5931 31.9253 44.73 35.3355 41.9521C35.7549 41.6105 36.3718 41.6735 36.7133 42.0929Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8803 22.9182C29.5516 22.4886 29.6335 21.874 30.063 21.5453C33.4786 18.9326 36.9874 17.1337 40.0843 16.387C43.1443 15.6492 46.0467 15.893 47.9123 17.7586C50.0802 19.9265 50.0667 23.4834 48.8322 27.1428C48.6593 27.6554 48.1036 27.9307 47.5912 27.7577C47.0786 27.5849 46.8034 27.0293 46.9763 26.5168C48.148 23.0434 47.8694 20.4856 46.5273 19.1436C45.3767 17.993 43.3397 17.6169 40.5435 18.2911C37.7844 18.9564 34.5204 20.6017 31.2531 23.101C30.8236 23.4297 30.2089 23.3478 29.8803 22.9182Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1012 26.7962C33.1012 30.5822 30.032 33.6514 26.2459 33.6514C22.4599 33.6514 19.3906 30.5822 19.3906 26.7962C19.3906 23.0101 22.4599 19.9409 26.2459 19.9409C30.032 19.9409 33.1012 23.0101 33.1012 26.7962ZM25.5602 23.3681H26.9312V26.1099H29.6723V27.481H26.9312V30.2233H25.5602V27.481H22.817V26.1099H25.5602V23.3681Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3838 39.1357V37.7646H38.4871V39.1357H43.3838Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2072_13253",
    x1: 62.8,
    y1: -0.00000616173,
    x2: -3.86844,
    y2: 12.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#31B047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2072_13253",
    x1: 32,
    y1: 64,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#31B047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CB0B",
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatterLogo);
export default __webpack_public_path__ + "static/media/matter_logo.7713e7bc.svg";
export { ForwardRef as ReactComponent };